<template lang="html">

  <section class="header" :min="min" :inside="inside">

    <div class="superior">

      <div class="container row-between">

        <nav class="type-selector">
          <router-link :active="inGeneric" to="/">Particulares</router-link>
          <router-link :active="inEmpresa" :to="$t('enlaces.empresas')">Empresas</router-link>
          <router-link :active="inAutoconsumo" :to="$t('enlaces.autoconsumo')">Autoconsumo</router-link>
        </nav>

        <div class="row-start">
          <div class="contactos">
            <a class="phone-icon" href="tel:900848402"><span @click="sendeventllamar">900 848 402</span></a>
            <a class="mail-icon" href="mailto:iner@inerenergia.es">iner@inerenergia.es</a>
          </div>
          <div class="right">
            <rrss></rrss>
          </div>
        </div>

      </div>

    </div>


    <div class="inferior" :show="showmenu">

      <div class="container contenedor-menu row-between">

        <router-link :to="$t(`enlaces.${tohome}`)" class="contenedor-logo column-center">
          <span>Somos</span>
          <img class="white" src="/static/img/logo-iner-blanco.svg" alt="Logo Iner">
          <img class="orange" src="/static/img/logo-iner-orange.svg" alt="Logo Iner naranja">
        </router-link>

        <nav class="menu-options row-start" v-if="inGeneric">
          <router-link :to="$t('enlaces.asi_somos')">Así somos</router-link>
          <router-link :to="$t('enlaces.que_ofrecemos')">Qué ofrecemos</router-link>
          <div class="tarifas-container" :show="showTarifas">
            <a :class="['row-center', ($route.meta.type == 'tarifa') ? 'router-link-active' : '']"
              @click="showTarifas = !showTarifas">
              <span>Tarifas</span>
            </a>
            <div class="menu-child">
              <router-link :to="$t('enlaces.tarifas_luz')">Luz</router-link>
              <router-link :to="$t('enlaces.tarifas_gas')">Gas</router-link>
              <router-link :to="$t('enlaces.tarifas_luzgas')">Luz y Gas</router-link>
              <router-link class="-mvl"  :to="$t('enlaces.luzempresas')">Luz empresas</router-link>
              <!-- <router-link class="-mvl" :to="$t('enlaces.autoconsumo_tarifas')">Autoconsumo</router-link> -->
            </div>
          </div>
          <router-link class="-mvl" :to="$t('enlaces.tarifas_luz')">Tarifas Luz</router-link>
          <router-link class="-mvl" :to="$t('enlaces.tarifas_gas')">Tarifas Gas</router-link>
          <router-link class="-mvl" :to="$t('enlaces.tarifas_luzgas')">Tarifas Luz y Gas</router-link>
          <router-link class="-mvl" :to="$t('enlaces.luzempresas')">Tarifa luz empresas</router-link>
          <router-link :to="$t('enlaces.blog')">Blog</router-link>
          <router-link :to="$t('enlaces.contacto')"  class="btn -white">CONTRATA</router-link>
          <a rel="noopener" target="_blank" href="https://clientes.inerenergia.es/login"
            class="zona-clientes -mvl column-start">
            <span class="big">Ya soy de Iner</span>
            <span class="small">Zona Clientes</span>
          </a>
        </nav>

        <nav class="menu-options row-start" :empresa="inEmpresa" v-if="inEmpresa">
          <router-link :to="$t('enlaces.luzempresas')">Tarifa luz</router-link>
          <router-link :to="$t('enlaces.teayudamos')">Te ayudamos</router-link>
          <router-link :to="$t('enlaces.contacto')"  class="btn -white">CONTRATA</router-link>
          <a rel="noopener" target="_blank" href="https://clientes.inerenergia.es/login"
            class="zona-clientes -mvl column-start">
            <span class="big">Ya soy de Iner</span>
            <span class="small">Zona Clientes</span>
          </a>
        </nav>


        <nav class="menu-options row-start -autoconsumo" :empresa="inAutoconsumo" v-if="inAutoconsumo">
          <router-link :to="$t('enlaces.autoconsumo')+'/viviendas'">Particulares</router-link>
          <router-link :to="$t('enlaces.autoconsumo')+'/empresas'">Empresas</router-link>
          <router-link :to="$t('enlaces.autoconsumo')+'/agricultura'">Agricultura</router-link>
          
          <router-link class="btn -white" :to="$t('enlaces.calculo_autoconsumo')">CALCULA TU AHORRO
          </router-link>
          <a rel="noopener" target="_blank" href="https://clientes.inerenergia.es/login"
            class="zona-clientes -mvl column-start">
            <span class="big">Ya soy de Iner</span>
            <span class="small">Zona Clientes</span>
          </a>
        </nav>

        <a rel="noopener" target="_blank" href="https://clientes.inerenergia.es/login"
          class="zona-clientes column-start" :empresa="inEmpresa" v-if="!inAutoconsumo">
          <span class="big">Ya soy de Iner</span>
          <span class="small">Zona Clientes</span>
        </a>

        <router-link class="btn -white -btn-contacta-autoconsumo" v-if="inAutoconsumo" :to="$t('enlaces.autoconsumo_ayudamos')">CONTACTA</router-link>

        <div class="mobile-things row-start">

          <router-link :to="$t('enlaces.contacto')" v-if="!inAutoconsumo"  class="btn -degree inergizate-claim">CONTRATA</router-link>
          <router-link :to="$t('enlaces.autoconsumo_ayudamos')" v-if="inAutoconsumo"  class="btn -degree inergizate-claim">CONTACTA</router-link>

          <button class="show-menu" @click="showmenu = !showmenu">
            <span></span>
            <span></span>
            <span></span>
          </button>

        </div>

      </div>

    </div>

  </section>

</template>

<script lang="js">

  import rrss from '@/components/parts/rrss'

  export default {
    name: 'app-header',
    data() {
      return {
        min: false,
        showTarifas: false,
        showmenu: false
      }
    },
    components: {
      'rrss': rrss
    },
    mounted() {
      let that = this;
      $(window).scroll(function () {
        let scroll = $(window).scrollTop();
        that.min = (scroll > 200);
      })
    },
    watch: {
      '$route'() {
        this.showTarifas = false;
        this.showmenu = false;
      }
    },
    computed: {
      inside() {
        let notinside = ['home', 'empresas','autoconsumo'];
        return (!notinside.some(e => e == this.$route.name))
      },
      inEmpresa() {
        return (!!this.$route.meta.inempresas);
      },
      inAutoconsumo() {
        return (!!this.$route.meta.inautoconsumo);
      },
      inGeneric() {
        return (!!!this.$route.meta.inautoconsumo && !!!this.$route.meta.inempresas);
      },
      tohome(){
        let link;

        if(this.inEmpresa){
          link = 'empresas';
        }else if(this.inAutoconsumo){
          link = 'autoconsumo'
        }else{
          link = 'home';
        }

        return link;

      }
    },
    methods: {
      sendeventllamar() {
        this.$ga.event({
          eventCategory: 'Home',
          eventAction: 'clic',
          eventLabel: 'clic-llamada',
          eventValue: 0
        });
      }
    }
  }
</script>

<style scoped>
  @import '@/assets/css/colors.scss'
  .header {}
</style>


// WEBPACK FOOTER //
// src/components/parts/header.vue